module.exports = __webpack_public_path__ + "img/adminBlack.84a92e6f.svg";